var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24798_12144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_24798_12144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.135 8L19.979 8.54693V24.4161L20.135 24.5767L27.2697 20.2225L20.135 8Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1349 8L13 20.2225L20.1349 24.5767V16.8743V8Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1348 25.9713L20.0469 26.082V31.7348L20.1348 31.9997L27.2739 21.6194L20.1348 25.9713Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1349 31.9997V25.9713L13 21.6194L20.1349 31.9997Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1348 24.5767L27.2695 20.2225L20.1348 16.8743V24.5767Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.2225L20.1349 24.5767V16.8743L13 20.2225Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24798_12144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_24798_12144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.274,
    height: 24,
    fill: "white",
    transform: "translate(13 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth-icon.d077306d52e6d2feef614b70f05408a7.svg";
export { ForwardRef as ReactComponent };